import Box from '@mui/material/Box';
import { SectionTitle, Subsection } from '../components/SectionPrimitives';

export function Section3(): JSX.Element {
  return (
    <Box>
      <SectionTitle>3. Intellectual Property</SectionTitle>

      <Subsection title="3.1 UKVG's Rights">
        All intellectual property rights in the UK Vineyard Guide platform, app,
        and associated marketing materials remain the sole property of UKVG.
        Nothing in the Agreement grants the Partner any rights in UKVG's
        intellectual property.
      </Subsection>

      <Subsection title="3.2 Partner's Rights">
        All intellectual property rights in the Partner's brand assets,
        including logos, trademarks, imagery, and campaign materials, remain the
        sole property of the Partner. The Partner grants UKVG a non-exclusive,
        royalty-free licence to use these assets solely for the purposes of
        delivering the agreed services during the term of the Agreement. This
        licence terminates automatically upon expiry or cancellation.
      </Subsection>

      <Subsection title="3.3 Partner Warranty">
        The Partner warrants that it holds the necessary rights to supply all
        assets provided under the Agreement and that UKVG's use of those assets
        will not infringe any third-party rights. The Partner shall indemnify
        UKVG against any claims arising from a breach of this warranty.
      </Subsection>

      <Subsection title="3.4 Asset Removal on Termination">
        Upon termination of the Agreement, UKVG shall cease use of the Partner's
        brand assets and remove them from the platform within 14 days.
      </Subsection>
    </Box>
  );
}
